// extracted by mini-css-extract-plugin
export default {"loading_spinner":"Spinner_loading_spinner__-YWp+","spinner":"Spinner_spinner__sGVz5"};